import {FC} from "react";
import {BaseIcon, IPropsIcon} from "./BaseIcon";

interface IProps extends IPropsIcon {

}

export const NextArrowIcon:FC<IProps> = ({size= 15,fill='none'})=>{
    return (
        <BaseIcon size={size} viewBox="0 0 8 12" fill={fill}>
            <path d="M7.375 6.84766C7.69141 6.53125 7.69141 6.00391 7.375 5.65234L2.59375 0.871094C2.24219 0.554688 1.71484 0.554688 1.39844 0.871094L0.589844 1.67969C0.273438 2.03125 0.273438 2.55859 0.589844 2.875L4 6.28516L0.589844 9.66016C0.273438 9.97656 0.273438 10.5039 0.589844 10.8555L1.39844 11.6289C1.71484 11.9805 2.24219 11.9805 2.59375 11.6289L7.375 6.84766Z" fill="#0D0D0E"/>
        </BaseIcon>
    )
}